import { useMemo } from 'react';
import { useSelector } from 'react-redux';
export const useSelectorWithProps = (selector, props) => {
    // as at this point it is not guarateed to be done on the outside
    // we do it here despite the fact that it is not a good practice
    // eslint-disable-next-line react-compiler/react-compiler
    const memSelector = useMemo(selector, []);
    return useSelector((state) => memSelector(state, ...Object.values(props)));
};
//# sourceMappingURL=useSelectorWithProps.js.map